var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<web-component> <div ng-switch on=\"status\"> <div ng-switch-when=\"init\"></div> <div ng-switch-when=\"out\"></div> <div ng-switch-when=\"waiting_for_parameter\"> </div> <div ng-switch-when=\"loading\"> <p ng-i18next>omaloma.destination_info.loading</p> </div> <div ng-switch-when=\"error\"></div> <div ng-switch-when=\"ready\" class=\"infobox row\"> <h3 class=\"titlefullwidth\" ng-i18next>omaloma.common.accommodations</h3> <winres-product-line ng-repeat=\"line in lines\" product-line=\"line\"></winres-product-line> </div> </div> </web-component>";
var id1="winresOmalomaAccommodations.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaAccommodations/winresOmalomaAccommodations.html
// module id = 320
// module chunks = 2